import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',  
  routes: [
    { path: '/', redirect: '/home' },
    {
      path : '/home',
      component: () => import('../components/Home.vue'),
    },{
      path : '/me',
      component: () => import('../components/Me.vue'),
    },{
      path : '/desc',
      component: () => import('../components/Desc.vue'),
    },{
      path : '/paysucc',
      component: () => import('../components/PaySucess.vue'),
    },
    ,{
      path : '/vip/:token',
      component: () => import('../components/Vip.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js